/**
 * Refusals of the inbound routing API that the UI answers at a field rather
 * than with the mutation's generic failure toast.
 */
import {
  INBOUND_ROUTING_PRIORITY_TAKEN,
  INBOUND_ROUTING_REORDER_CONFLICT,
} from '@aica/api-types/schemas';
import { ApiError } from '@/lib/fetch-utils';

const isRefusal = (error: unknown, status: number, code: string): boolean =>
  error instanceof ApiError &&
  error.status === status &&
  (error.data as { code?: unknown } | undefined)?.code === code;

/** The server refused a manual priority another rule of the organization holds (#2949). */
export const isPriorityTaken = (error: unknown): boolean =>
  isRefusal(error, 409, INBOUND_ROUTING_PRIORITY_TAKEN);

/** The organization's rules changed under a reorder (#2874): nothing was saved. */
export const isReorderConflict = (error: unknown): boolean =>
  isRefusal(error, 409, INBOUND_ROUTING_REORDER_CONFLICT);
